export default __webpack_public_path__ + "static/media/ic-phone.1c244bd5.svg";